import { Agent } from './agent';
export class Group extends Agent {
    objectType = 'Group';
    members;
    constructor(cfg) {
        super(cfg);
        this.members = [];
        this.init(cfg);
    }
    init(cfg = {}) {
        if (cfg.members) {
            this.members = cfg.members.map((member) => {
                if (member instanceof Agent) {
                    return member;
                }
                return new Agent(member);
            });
        }
        super.init(cfg);
    }
    toString() {
        let result = super.toString();
        if (result !== `${this.objectType}: unidentified`) {
            result = `${this.objectType}: ${result}`;
        }
        return result;
    }
    asVersion(version = '1.0.3') {
        const result = super.asVersion(version);
        if (this.members.length > 0) {
            result.members = this.members.map((member) => member.asVersion(version));
        }
        return result;
    }
    static fromJSON(groupJSON) {
        const _group = JSON.parse(groupJSON);
        return new Group(_group);
    }
}
